import $ from 'jquery';
import config from './../../../config';

// Get Meetings
export function upload_files( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'requests/onboard/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "ON_UPLOADED_PROFILE_PIC",
				onboard: response
			})
		})

	}

}


export function save_onboard( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/onboard/',
			data: {
				method: 'SAVE_ONBOARD',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_ONBOARD",
				onboard: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/onboarding/actions/onboarding.action.js